import * as R from 'remeda';
import { createSelector } from 'reselect';
import { isTrialSelector } from '../../../redux/modules/organization/selectors';
import { userSelector } from '../../../redux/modules/user/selectors';
import {
  isEmbeddedBlocker,
  isInternalUserBlocker,
  isTrialBlocker,
} from '../blockers';

export const discoveryCallSurveyBlockersSelector = createSelector(
  userSelector,
  isTrialSelector,
  (currentUser, isTrial) => {
    return [
      // no survey in embedded mode
      isEmbeddedBlocker(),
      // do not show to internal users
      isInternalUserBlocker(currentUser),
      // do not show to trial users
      isTrialBlocker(isTrial),
    ].filter(R.isTruthy);
  }
);
